
import Card from '@/ui-kit/components/card/Card';
import CardTitle from '@/ui-kit/components/card/CardTitle';
import CardActions from '@/ui-kit/components/card/CardActions';
import CardContent from '@/ui-kit/components/card/CardContent';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import LayoutGridContainer from '@/ui-kit/components/layout-grid/container';
import LayoutGridItem from '@/ui-kit/components/layout-grid/item';
import { ButtonFillType, ButtonProperty } from '@/ui-kit/components/button/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { LayoutItemProperty, LayoutItemColumn } from '@/ui-kit/components/layout-grid/item/enums';
import { LayoutContainerProperty } from '@/ui-kit/components/layout-grid/container/enums';
import {
  StyleColorSchemeType,
  StyleFontWeightType,
  StylePositionType,
  StyleSizeType,
} from '@/ui-kit/styles/enums';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import Spinner from '@/ui-kit/components/spinner';

export default {
  name: 'MarketDataSummaryTableCard',
  components: {
    Card,
    CardTitle,
    CardActions,
    CardContent,
    Typography,
    Button,
    LayoutGridContainer,
    LayoutGridItem,
    Spinner,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      TypographyProperty,
      TypographyType,
      ButtonProperty,
      ButtonFillType,
      StyleFontWeightType,
      LayoutItemProperty,
      LayoutItemColumn,
      LayoutContainerProperty,
    };
  },
};
